import { useGlobalStore } from '@highlight/ipc/react'
import { AttachmentPermission, AttachmentTypes } from '@shared/types/Attachments.ts'
import { useMemo } from 'react'
import { getDefaultAttachmentPermission } from '@shared/store/impl/settings.ts'

export const useAttachmentPermission = (attachmentType: AttachmentTypes) => {
  const [permission, setPermission] = useGlobalStore<AttachmentPermission>(
    'settings',
    `attachmentAndDetectionPermissions.${attachmentType}`,
    getDefaultAttachmentPermission(attachmentType),
  )

  const isLocked = useMemo(() => {
    return permission === 'locked'
  }, [permission])

  const canDetect = useMemo(() => {
    return ['detect', 'notify'].includes(permission)
  }, [permission])

  const canNotify = useMemo(() => {
    return permission === 'notify'
  }, [permission])

  return {
    permission,
    isLocked,
    canDetect,
    canNotify,
    setPermission,
  }
}
